import _asyncToGenerator from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/builds/raisin-global/raisin-us/savebetter/savebetter/node_modules/@babel/runtime/regenerator/index.js";
import { useState as f, useEffect as u } from "react";
import { registerStoryblokBridge as k } from "./storyblok-js.mjs";
import { RichTextResolver as v, RichTextSchema as x, apiPlugin as R, loadStoryblokBridge as C, renderRichText as w, storyblokEditable as B } from "./storyblok-js.mjs";
import { useStoryblokApi as c } from "./index2.mjs";
import { getComponent as h, getCustomFallbackComponent as A, getEnableFallbackComponent as T, setComponents as F, storyblokInit as I } from "./index2.mjs";
import { useStoryblokState as P } from "./client.mjs";
import { default as J } from "./storyblok-component.mjs";

var b = function b(s) {
  var _o$resolveRelations, _o$resolveLinks;

  var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _f = f({}),
      _f2 = _slicedToArray(_f, 2),
      l = _f2[0],
      n = _f2[1];

  var i = typeof window < "u" && typeof window.storyblokRegisterEvent < "u",
      t = c();
  return u(function () {
    if (!t) {
      console.error("You can't use useStoryblok if you're not loading apiPlugin.");
      return;
    }

    function a() {
      return _a.apply(this, arguments);
    }

    function _a() {
      _a = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$t$get, r;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return t.get("cdn/stories/".concat(s), e);

              case 2:
                _yield$t$get = _context.sent;
                r = _yield$t$get.data;
                n(r.story), i && r.story.id && k(r.story.id, function (y) {
                  return n(y);
                }, o);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _a.apply(this, arguments);
    }

    a();
  }, [s, JSON.stringify(e), t]), t ? (o.resolveRelations = (_o$resolveRelations = o.resolveRelations) !== null && _o$resolveRelations !== void 0 ? _o$resolveRelations : e.resolve_relations, o.resolveLinks = (_o$resolveLinks = o.resolveLinks) !== null && _o$resolveLinks !== void 0 ? _o$resolveLinks : e.resolve_links, l) : null;
};

export { v as RichTextResolver, x as RichTextSchema, J as StoryblokComponent, R as apiPlugin, h as getComponent, A as getCustomFallbackComponent, T as getEnableFallbackComponent, c as getStoryblokApi, C as loadStoryblokBridge, k as registerStoryblokBridge, w as renderRichText, F as setComponents, B as storyblokEditable, I as storyblokInit, b as useStoryblok, c as useStoryblokApi, k as useStoryblokBridge, P as useStoryblokState };